import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { applyStoredLook } from "./app/look";
import { isMicrosoftAnswer } from "./app/microsoft";
import "./styles/app.css";

// Classic or Liquid Glass, and the text size, before anything is drawn.
applyStoredLook();

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

// Microsoft's answer to a sign-in is in the address. In the popup, the window
// that opened it reads the answer and closes it, so nothing starts here. After
// a full-page redirect, sign-in finishes first, and only then does the app,
// whose router would otherwise have rewritten the address unread. A quiet ask
// (the Outlook calendar's) answers into a hidden frame, read the same way.
const inPopup = window.opener && window.opener !== window;
const inFrame = window.parent !== window;
if (!(isMicrosoftAnswer() && (inPopup || inFrame))) {
  void (async () => {
    if (isMicrosoftAnswer()) {
      const { finishSignIn } = await import("./pages/SignIn");
      await finishSignIn();
    }
    const { App } = await import("./app/App");
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })();
}
